/* eslint-disable import/prefer-default-export */
import axios from '@axios'

export const fetchRolesList = async (params?: any): Promise<any> => {
  const res = await axios.get('/auth/roles', { params })
  return res
}
